import { Cat } from '../types';

const configString = document.getElementById('config-data')?.dataset?.configData;

type ConfigType = {
    mediaServer: string;
    botLink: string;
    cat: Cat;
    csrf: string;
    dataOne: string;
    dataTwo: string;
    description: string | null;
}

const config: ConfigType = configString ? JSON.parse(decodeURIComponent(configString)) : {};

export const MEDIA_SERVER: string | undefined = config.mediaServer;
export const BOT_LINK: string | undefined = config.botLink;
// export const ADV_BLOCK_ID: string | undefined = config.advBlockId;
export const CAT: Cat | undefined = config.cat;
export const CSRF: string | undefined = config.csrf;
export const DATA_ONE: string | undefined = config.dataOne;
export const DATA_TWO: string | undefined = config.dataTwo;
export const DESCRIPTION: string | null = config.description;
